import createVueApp from '@/common/create_app'

Styxie.Initializers.ProfileBilling = {
  subscriptions: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/billing_subscriptions/index.vue')
    createVueApp(Component, { props })
  }
}
